import { parseTemplate } from 'url-template';
import { mapPagination, Pagination } from '~/Api/Pagination';
import ApiClient from '~/ApiClient';

import BrandQuery from './BrandQuery';
import mapRecord from './mapRecord';
import Record from './Record';

export interface Result {
	items: Record[];
	pagination: Pagination;
}

export default async function findBrandHistory(
	client: ApiClient,
	query: BrandQuery,
	page: number,
	perPage: number
): Promise<Result> {
	const { id, currency } = query;
	const url = parseTemplate('analytics/virtual-brands/{id}/history{?include-context,currency,page,perPage}');
	const params = {
		id,
		'include-context': true,
		page,
		perPage,
		currency: currency == 'source' ? null : currency,
	};
	const request = await client.fetch(url.expand(params));
	const response = await request.json();
	return {
		items: response.items.map(mapRecord),
		pagination: mapPagination(response.pagination),
	};
}
